<section *ngIf="form"
         class="queue-container">

    <ui-card-info [message]="'queue_trigger_info_card' | translate">
    </ui-card-info>

    <form [formGroup]="form">
        <mat-form-field *ngLet="getField('queue') as queue"
                        class="queue-field-wrapper">
            <ui-suggest [placeholder]="'triggers_upsert_queue' | translate"
                        [defaultValue]="'triggers_upsert_queue_empty' | translate"
                        [searchSourceFactory]="queueSearchFactory"
                        [formControlName]="fields.queue"
                        [clearable]="false"
                        data-cy="triggers-queue-form-select">
            </ui-suggest>
            <mat-error *ngIf="queue.hasError('hasProcess')"
                       [translateParams]="{
                            process: queue.getError('hasProcess')
                        }"
                       translate>
                triggers_queue_with_trigger_already
            </mat-error>
        </mat-form-field>

        <ng-container *ngLet="{
            maxJobsForActivation: getField('maxJobsForActivation'),
            itemsActivationThreshold: getField('itemsActivationThreshold'),
            itemsPerJobActivationTarget: getField('itemsPerJobActivationTarget')
        } as queueFields">
            <div [matTooltip]="'queue_trigger_min_item_tooltip' | translate"
                 class="layout-row layout-align-v-start layout-align-h-center">
                <div class="layout-row layout-align-v-right layout-align-h-center">
                    <label translate>queue_trigger_min_item_prefix</label>
                </div>
                <div class="layout-row layout-align-v-left layout-align-h-center flex-15 input-wrap">
                    <mat-form-field>
                        <input [attr.max]="itemsActivationThresholdMax"
                               [formControlName]="fields.itemsActivationThreshold"
                               type="number"
                               min="1"
                               data-cy="triggers-queue-form-itemsActivationThreshold"
                               matInput
                               required />
                    </mat-form-field>
                </div>
                <div class="layout-row layout-align-v-left layout-align-h-center">
                    <label translate>queue_trigger_min_item_suffix</label>
                </div>

                <ng-container *ngTemplateOutlet="rangeWarning; context:{
                                  formControl: queueFields.itemsActivationThreshold
                            } ">
                </ng-container>
            </div>

            <div [matTooltip]="'queue_trigger_max_jobs_tooltip' | translate"
                 class="layout-row layout-align-v-start layout-align-h-center">
                <div class="layout-row layout-align-v-right layout-align-h-center">
                    <label translate>queue_trigger_max_jobs_prefix</label>
                </div>
                <div class="layout-row layout-align-v-left layout-align-h-center flex-15 input-wrap">
                    <mat-form-field>
                        <input (change)="changedMaxJobsForActivation($event.target.value)"
                               [attr.max]="maxJobsForActivationMax"
                               [formControlName]="fields.maxJobsForActivation"
                               type="number"
                               min="1"
                               data-cy="triggers-queue-form-maxJobsForActivation"
                               matInput
                               required />
                    </mat-form-field>
                </div>
                <div class="layout-row layout-align-v-left layout-align-h-center">
                    <label translate>queue_trigger_max_jobs_suffix</label>
                </div>

                <ng-container *ngTemplateOutlet="rangeWarning; context:{
                                    formControl: queueFields.maxJobsForActivation
                                } ">
                </ng-container>
            </div>

            <div [matTooltip]="'queue_trigger_job_after_tooltip' | translate"
                 [class.disabled]="queueFields.maxJobsForActivation.value == 1"
                 class="layout-row layout-align-v-start layout-align-h-center">
                <div class="layout-row layout-align-v-right layout-align-h-center">
                    <label translate>queue_trigger_job_after_prefix</label>
                </div>
                <div class="layout-row layout-align-v-left layout-align-h-center flex-15 input-wrap">
                    <mat-form-field>
                        <input [attr.max]="itemsPerJobActivationTargetMax"
                               [readonly]="queueFields.maxJobsForActivation.value == 1"
                               [formControlName]="fields.itemsPerJobActivationTarget"
                               type="number"
                               min="1"
                               data-cy="triggers-queue-form-itemsPerJobActivationTarget"
                               matInput
                               required />
                    </mat-form-field>
                </div>
                <div class="layout-row layout-align-v-left layout-align-h-center">
                    <label translate>queue_trigger_job_after_suffix</label>
                </div>

                <ng-container *ngTemplateOutlet="rangeWarning; context:{
                                  formControl: queueFields.itemsPerJobActivationTarget
                                } ">
                </ng-container>
            </div>
        </ng-container>

    </form>
    <mat-divider></mat-divider>
</section>

<ng-template #rangeWarning
             let-formControl="formControl">
    <mat-error *ngIf="formControl.hasError('range')"
               [translateParams]="{
                    min: formControl.getError('range').min,
                    max: formControl.getError('range').max
                }"
               translate>
        input_number_range_warning
    </mat-error>
</ng-template>
